import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css']
})
export class CalendarioComponent implements OnInit, OnChanges {

  @Input() fecha!: string; // formato MySQL: YYYY-MM-DD

  fechaDate!: Date;
  semanas: (number | null)[][] = [];
  mes!: number;
  anio!: number;
  diaSeleccionado!: number;
  hoy = new Date();
  diaHoy!: number;
  mesHoy!: number;
  anioHoy!: number;

  ngOnInit() {
    this.generarCalendario();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['fecha']) {
      this.generarCalendario();
    }
  }

  private parseFecha(fechaStr: string): Date {
    const [anio, mes, dia] = fechaStr.split('-').map(Number);
    return new Date(anio, mes - 1, dia);
  }

  generarCalendario() {
    if (!this.fecha) return;

    this.diaHoy = this.hoy.getDate();
    this.mesHoy = this.hoy.getMonth();
    this.anioHoy = this.hoy.getFullYear();

    const fechaDate = this.parseFecha(this.fecha);
    this.fechaDate = fechaDate;

    this.mes = fechaDate.getMonth();
    this.anio = fechaDate.getFullYear();
    this.diaSeleccionado = fechaDate.getDate();

    const primerDia = new Date(this.anio, this.mes, 1);
    const ultimoDia = new Date(this.anio, this.mes + 1, 0);

    const diasMes = ultimoDia.getDate();
    const diaInicio = (primerDia.getDay() + 6) % 7; // lunes = 0

    let semanas: (number | null)[][] = [];
    let semana: (number | null)[] = [];

    // huecos iniciales
    for (let i = 0; i < diaInicio; i++) {
      semana.push(null);
    }

    // días del mes
    for (let dia = 1; dia <= diasMes; dia++) {
      semana.push(dia);

      if (semana.length === 7) {
        semanas.push(semana);
        semana = [];
      }
    }

    // completar última semana
    if (semana.length > 0) {
      while (semana.length < 7) {
        semana.push(null);
      }
      semanas.push(semana);
    }

    this.semanas = semanas;
  }

  esDiaPasado(dia: number | null): boolean {
    if (!dia) return false;

    // Solo tiene sentido comparar dentro del mismo mes mostrado
    const esMismoMesQueHoy =
      this.mes === this.mesHoy &&
      this.anio === this.anioHoy;

    if (!esMismoMesQueHoy) return false;

    return dia < this.diaHoy;
  }

  esFinDeSemana(indexDiaSemana: number): boolean {
    // 0 = lunes ... 5 = sábado ... 6 = domingo (según tu grid L M X J V S D)
    return indexDiaSemana === 5 || indexDiaSemana === 6;
  }
}